import {
  IconBell,
  IconCar,
  IconCalendar,
  IconSpeed,
  IconWrench,
  IconChevron,
} from "./NotificationIcons";
import {
  formatJalaliDate,
  formatMileage,
  toPersianDigits,
  getReasonKind,
  getReasonText,
  getServiceTitle,
  getVehicleTitle,
  getOverdueDays,
  getOverdueKm,
} from "./notificationUtils";

function NotificationCard({ reminder, isOpen, onToggle }) {
  const kind = getReasonKind(reminder);
  const reasonText = getReasonText(kind);
  const serviceTitle = getServiceTitle(reminder);
  const vehicleTitle = getVehicleTitle(reminder);
  const dueDateStr = formatJalaliDate(reminder?.nextDueDate);
  const dueKmStr =
    reminder?.nextDueKm !== null && reminder?.nextDueKm !== undefined
      ? `${formatMileage(reminder.nextDueKm)} کیلومتر`
      : "—";
  const currentKmStr = formatMileage(reminder?.vehicle?.currentMileage);
  const overdueDays = getOverdueDays(reminder);
  const overdueKm = getOverdueKm(reminder);

  return (
    <div
      className={`nt-card${isOpen ? " is-open" : ""}`}
      dir="rtl"
      data-testid={`notification-card-${reminder?.id}`}
    >
      <div
        className="nt-card__header"
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <div className="nt-card__type">
          <span className="nt-card__icon-box" aria-hidden="true">
            <IconBell />
          </span>
          <span className="nt-card__type-text">{serviceTitle}</span>
        </div>
        <span className="nt-card__chevron" aria-hidden="true">
          <IconChevron open={isOpen} />
        </span>
      </div>

      <div className="nt-card__summary">
        <span className="nt-card__badge" data-kind={kind}>
          {reasonText}
        </span>
      </div>

      <div className="nt-card__summary nt-card__summary--sub">
        <span className="nt-card__summary-item">
          <IconCar />
          {vehicleTitle}
        </span>
        <span className="nt-card__summary-sep" aria-hidden="true">
          •
        </span>
        <span className="nt-card__summary-item">
          <IconCalendar />
          {dueDateStr}
        </span>
      </div>

      <div
        className={`nt-card__expand${isOpen ? " is-open" : ""}`}
        aria-hidden={!isOpen}
      >
        <div className="nt-card__expand-inner">
          <div className="nt-card__grid">
            <div className="nt-card__meta">
              <span className="nt-card__meta-icon" aria-hidden="true">
                <IconCar />
              </span>
              <span className="nt-card__meta-label">خودرو</span>
              <span className="nt-card__meta-value">{vehicleTitle}</span>
            </div>

            <div className="nt-card__meta">
              <span className="nt-card__meta-icon" aria-hidden="true">
                <IconWrench />
              </span>
              <span className="nt-card__meta-label">نوع سرویس</span>
              <span className="nt-card__meta-value">{serviceTitle}</span>
            </div>

            <div className="nt-card__meta">
              <span className="nt-card__meta-icon" aria-hidden="true">
                <IconCalendar />
              </span>
              <span className="nt-card__meta-label">موعد مقرر</span>
              <span className="nt-card__meta-value">
                {dueDateStr}
                {overdueDays > 0
                  ? ` (${toPersianDigits(overdueDays)} روز پیش)`
                  : ""}
              </span>
            </div>

            <div className="nt-card__meta">
              <span className="nt-card__meta-icon" aria-hidden="true">
                <IconSpeed />
              </span>
              <span className="nt-card__meta-label">کیلومتر مقرر</span>
              <span className="nt-card__meta-value">
                {dueKmStr}
                {overdueKm > 0
                  ? ` (${formatMileage(overdueKm)} گذشته)`
                  : ""}
              </span>
            </div>

            <div className="nt-card__meta">
              <span className="nt-card__meta-icon" aria-hidden="true">
                <IconSpeed />
              </span>
              <span className="nt-card__meta-label">کیلومتر فعلی</span>
              <span className="nt-card__meta-value">
                {currentKmStr} کیلومتر
              </span>
            </div>

            <div className="nt-card__meta nt-card__meta--full">
              <span className="nt-card__meta-label">وضعیت</span>
              <span className="nt-card__meta-value nt-card__meta-value--wrap">
                {reasonText} — لطفاً برای ثبت سرویس به بخش ثبت سرویس مراجعه
                کنید
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationCard;
